import { get, post, put, deleteRequest } from "../web.request";

export const LanguageList = async (query) => {
    return await get(`/languageList${query}`);
};

export const LanguageCreate = async (data) => {
    return await post(`/languageCreate`, data);
};

export const LanguageUpdate = async (id, data) => {
    return await put(`/languageUpdate/${id}`, data);
};

export const LanguageDetail = async (id) => {
    return await get(`/languageDetail/${id}`);
};

export const LanguageDelete = async (id) => {
    return await deleteRequest(`/languagedelete/${id}`);
};

export const LanguageStatusUpdate = async (id, data) => {
    return await put(`/languageStatusUpdate/${id}`, data);
};
